var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('b-alert',{staticClass:"myAlert center warning",attrs:{"show":""}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.declineMessage)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }